import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface AwardsEarnedHistoryResponse {
  awards_earned_history: {
    student_id: number
    gold: number
    silver: number
    bronze: number
  }[]
}

export type AwardsEarnedHistoryData = AwardsEarnedHistoryResponse['awards_earned_history'][number]

export async function awardsEarnedHistory(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<AwardsEarnedHistoryData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('awards_earned_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<AwardsEarnedHistoryResponse>(url, query)
  if (!data) return null

  const { awards_earned_history: history } = data
  if (history.length === 0) return null

  return history
}
